import { useNotify, useRecordContext, useRefresh } from "react-admin";
import { Button, Typography } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { notificationsRequests } from "api/notificationsApi";

const ResendEmailButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(notificationsRequests.resendEmail(record.id), null, "POST");
    notify("Имейлът е изпратен повторно успешно", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleConfirm}
      titleContent="Повторно изпращане на имейл"
      triggerButton={
        <Button
          label="Изпрати отново"
          size="small"
          startIcon={<ReplayIcon />}
        >
          Изпрати отново
        </Button>
      }
    >
      <Typography sx={{ p: 4 }}>
        Темплейт: {record.template}
        <br />
        <br />
        <strong>Сигурни ли сте, че искате да изпратите имейла повторно?</strong>
      </Typography>
    </ConfirmModal>
  );
};

export default ResendEmailButton;
